import * as building from "./index";
import BuildingFormContainer from "../containers/BuildingFormContainer";
import BuildingsContainer from "../containers/BuildingsContainer";
import BuildingSheetDetailsContainer from "../containers/BuildingSheetDetailsContainer";

export const BuildingRoutes = [
  {
    key: "new-building",
    exact: true,
    path: building.NEW_BUILDING,
    component: BuildingFormContainer,
  },
  {
    key: "buildings",
    exact: true,
    path: building.BUILDINGS,
    component: BuildingsContainer,
  },
  {
    key: "buildings-details",
    exact: true,
    path: building.BUILDING_DETAILS,
    component: BuildingSheetDetailsContainer,
  },
  {
    key: "update-building",
    exact: true,
    path: building.UPDATE_BUILDING,
    component: BuildingFormContainer,
  },
];
